// extracted by mini-css-extract-plugin
module.exports = {"content":"lsom6","audio":"uneK6","spacing_medium":"opV1B","spacing_large":"_1Aza6"};